import { stringify } from 'qs';
import SuperFetchV2 from '../../superFetchV2';
import {
  AdminExcelDownloadAcceptedResponseType,
  SettlementItemsBulkUpdateRequestBodyDto,
  SettlementItemsBulkUpdateResponseDto,
  SettlementItemsFindAllResponseDto,
  SettlementItemsFindAndDownloadExcelRequestBodyDto,
  SettlementItemsFindOneResponseDto,
  SettlementItemsFindTotalByStatusResponseDto,
  SettlementItemsFindTotalResponseDto,
} from '../../../types/api/settlement-items';
import {
  SettlementItemsByBrandQueryParams,
  SettlementItemsQueryParams,
  SettlementItemsTotalByStatusQueryParams,
} from '../../../views/settlement/types/apis';
import {
  BrandSettlementsFindAllResponseDto,
  BrandSettlementsFindAndDownloadExcelRequestBodyDto,
} from '../../../types/api/brands';

export const settlementApi = {
  getSettlementItems: (params: SettlementItemsQueryParams): Promise<SettlementItemsFindAllResponseDto> =>
    SuperFetchV2.get('/settlement-items', {
      params,
      paramsSerializer: (params) => {
        return stringify(params, { arrayFormat: 'comma' });
      },
    }),
  getSettlementItem: (settlementItemId: number): Promise<SettlementItemsFindOneResponseDto> =>
    SuperFetchV2.get(`/settlement-items/${settlementItemId}`),
  getSettlementItemsTotal: (params: SettlementItemsQueryParams): Promise<SettlementItemsFindTotalResponseDto> =>
    SuperFetchV2.get('/settlement-items/total', {
      params,
      paramsSerializer: (params) => {
        return stringify(params, { arrayFormat: 'comma' });
      },
    }),
  getSettlementItemsTotalByStatus: (
    params: SettlementItemsTotalByStatusQueryParams,
  ): Promise<SettlementItemsFindTotalByStatusResponseDto> =>
    SuperFetchV2.get('/settlement-items/total-by-status', {
      params,
      paramsSerializer: (params) => {
        return stringify(params, { arrayFormat: 'comma' });
      },
    }),
  getSettlementItemsByBrand: (params: SettlementItemsByBrandQueryParams): Promise<BrandSettlementsFindAllResponseDto> =>
    SuperFetchV2.get('/brands/settlements', {
      params,
      paramsSerializer: (params) => {
        return stringify(params, { arrayFormat: 'comma' });
      },
    }),

  downloadSettlementItemsExcel: (
    request: SettlementItemsFindAndDownloadExcelRequestBodyDto,
  ): Promise<AdminExcelDownloadAcceptedResponseType> => {
    // FIXME: 보성
    // @ts-expect-error SuperFetchV2의 인터셉터 문제를 바로 잡아야 함
    return SuperFetchV2.post<Promise<AdminExcelDownloadAcceptedResponseType>>(
      '/settlement-items/excel-download',
      request,
    );
  },

  bulkUpdateSettlementItems: (
    request: SettlementItemsBulkUpdateRequestBodyDto,
  ): Promise<SettlementItemsBulkUpdateResponseDto> => {
    // FIXME: 보성
    // @ts-expect-error SuperFetchV2의 인터셉터 문제를 바로 잡아야 함
    return SuperFetchV2.patch<Promise<SettlementItemsBulkUpdateResponseDto>>('/settlement-items/bulk', request);
  },
};
